<app-header backgroundImage="assets/header/contact.webp"
            i18n-title title="Kontakt"
            i18n-description
            description="Treten Sie mit uns in Kontakt, damit wir auch Ihren IT-Alltag vereinfachen können."/>

<main>
  <section>
    <div class="card card-padding shear">
      <div class="shear-inner bg-before">
        <div class="inner-content">
          <h1 class="text-center pt-4" i18n>ser.soft GmbH</h1>
          <div class="row mt-5">
            <div class="col-12 col-lg-6 mb-4 mb-lg-0">
              <h3 i18n>Zentrale:</h3>
              <div class="d-flex flex-column gap-3">
                <div class="d-flex flex-row flex-wrap gap-2 align-items-baseline">
                  <i class="bi bi-building"></i>
                  <div class="d-flex flex-column">
                    <span i18n>ser.soft GmbH</span>
                    <span i18n>Gräfental 7</span>
                    <span i18n>75057 Kürnbach</span>
                  </div>
                </div>
                <div class="d-flex flex-row flex-wrap gap-2 align-items-baseline">
                  <i class="bi bi-telephone"></i>
                  <a href="tel:00497219351960" i18n>0721-93519-60</a>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              @if (mapsEmbedSrc) {
                <iframe [src]="mapsEmbedSrc" width="100%" height="480"></iframe>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section>
    <div class="card card-padding shear">
      <div class="shear-inner bg-before">
        <div class="inner-content pt-2">
          <div class="row">
            <div class="col-12 col-lg-6">
              <h3 i18n>Haben Sie noch Fragen?</h3>
              <p i18n>
                Sie können uns gerne über dieses Kontaktformular oder über die oben stehenden Kontaktdaten erreichen.
                Wir sind für Sie da!
              </p>
            </div>
            <div class="col-12 col-lg-6 contact-form">
              <h3 i18n>Wir freuen uns auf Ihre Nachricht!</h3>
              <form id="contact-form" [formRoot]="contactForm"
                    class="needs-validation row pt-3" [class.pb-3]="!contactForm().submitting() && !contactFormSubmission()">
                <div class="field col-12 col-lg-6 mb-3">
                  <input type="text" class="form-control" [formField]="contactForm.sender.name"
                         i18n-placeholder placeholder="Name, Vorname"/>
                  <div class="invalid-feedback" i18n>Dieses Feld darf nicht leer bleiben.</div>
                </div>
                <div class="field col-12 col-lg-6 mb-3">
                  <input type="email" class="form-control" [formField]="contactForm.sender.email"
                         i18n-placeholder placeholder="E-Mail"/>
                  <div class="invalid-feedback" i18n>Bitte geben Sie eine gültige E-Mail-Adresse ein.</div>
                </div>

                <div class="field col-12 mb-3">
                  <input type="text" class="form-control" [formField]="contactForm.subject"
                         i18n-placeholder placeholder="Betreff"/>
                  <div class="invalid-feedback" i18n>Dieses Feld darf nicht leer bleiben.</div>
                </div>

                <div class="field col-12 mb-3">
                <textarea rows="4" class="form-control" [formField]="contactForm.message"
                          i18n-placeholder placeholder="Nachricht"></textarea>
                  <div class="invalid-feedback" i18n>Dieses Feld darf nicht leer bleiben.</div>
                </div>

                <div class="field col-12 mb-3">
                  <button type="submit" class="btn btn-info"
                          [disabled]="!contactForm().valid() || contactForm().submitting()">
                    @if (contactForm().submitting()) {
                      <span class="spinner-border spinner-border-sm me-3" aria-hidden="true"></span>
                      <span role="status" i18n>Senden&hellip;</span>
                    } @else {
                      <span i18n>Senden</span>
                    }
                  </button>
                </div>
                @switch (contactFormSubmission()) {
                  @case (undefined) {}
                  @case ('sent') {
                    <div class="col-12 mt-3 alert alert-success" role="alert" i18n>
                      Vielen Dank für Ihre Nachricht!
                    </div>
                  }
                  @case ('error') {
                    <div class="col-12 mt-3 alert alert-danger" role="alert" i18n>
                      Beim Senden Ihrer Nachricht ist leider etwas schiefgelaufen.
                    </div>
                  }
                }
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
